import { FeedbackTab, useSupportContext } from "@/stores";
import { Divider, Stack, Tab, Tabs } from "@mui/material";
import { FC } from "react";
import { ChatsList } from "../chats-list";
import { NewFeedbacksList } from "../new-feedbacks-list";
import { useGetFeedbacks } from "../../queries";

const Feedbacks: FC = () => {
  const { feedbackTab, dispatch } = useSupportContext();
  const { feedbacks } = useGetFeedbacks();

  const onChangeFeedbackTab = (_: unknown, value: FeedbackTab) => {
    dispatch({ type: "SET_FEEDBACK_TAB", payload: value });
  };

  const feedbackTabs = [
    {
      value: FeedbackTab.NEW_FEEDBACKS,
      label: `New ${
        feedbacks?.data.length !== 0
          ? `(${feedbacks?.data.length ?? 0 + 1})`
          : ""
      }`,
    },
    {
      value: FeedbackTab.IN_PROGRESS,
      label: "Your Chats",
    },
  ];

  return (
    <Stack maxHeight={"100%"}>
      <Tabs
        value={feedbackTab}
        onChange={onChangeFeedbackTab}
        variant="fullWidth"
      >
        {feedbackTabs.map((tabProps) => (
          <Tab key={tabProps.value} {...tabProps} />
        ))}
      </Tabs>

      {feedbackTab === FeedbackTab.NEW_FEEDBACKS && <NewFeedbacksList />}
      {feedbackTab === FeedbackTab.IN_PROGRESS && (
        <>
          <Divider sx={{ marginTop: 4 }} />
          <ChatsList />
        </>
      )}
    </Stack>
  );
};

export { Feedbacks };
